import * as stylex from '@stylexjs/stylex';
import { MdGroups, MdPublic, MdPeople, MdLock, MdPerson, MdCake, MdHowToReg } from 'react-icons/md';
import { UserAvatar } from '~components/UserAvatar';
import { styles } from './styles';
import type { PublicSpotGroup } from '~pages/Spot/query';
export function Tribys({
  groups
}: {
  groups: PublicSpotGroup[];
}) {
  return <section {...stylex.props(styles.section)}>
      <div {...stylex.props(styles.header)}>
        <MdGroups size={24} {...stylex.props(styles.headerIcon)} />
        <h2 {...stylex.props(styles.headerTitle)}>Tribys</h2>
      </div>
      <div {...stylex.props(styles.list)}>
        {groups.map(group => <TribyCard key={group.id} group={group} />)}
      </div>
    </section>;
}
function TribyCard({
  group
}: {
  group: PublicSpotGroup;
}) {
  const full = group.memberCount >= group.maxSize;
  const pct = group.maxSize > 0 ? Math.min(100, Math.round(group.memberCount / group.maxSize * 100)) : 0;
  const fill = stylex.props(styles.fill, full && styles.fillFull);
  return <article {...stylex.props(styles.card)}>
      {group.members.length > 0 && <div {...stylex.props(styles.avatars)}>
          {group.members.map(member => <UserAvatar key={member.id} initials={member.initials} avatarUrl={member.avatarUrl} hidden={member.hidden} size={72} />)}
        </div>}

      <div {...stylex.props(styles.body)}>
        <h3 {...stylex.props(styles.title)}>{group.title}</h3>

        <div {...stylex.props(styles.pills)}>
          <Visibility value={group.visibility} />
          <Gender value={group.genderPolicy} />
          <span {...stylex.props(styles.pill, styles.pillAge)}>
            <MdCake size={16} {...stylex.props(styles.ageIcon)} />
            {group.ageRange.min}–{group.ageRange.max}
          </span>
        </div>

        <div {...stylex.props(styles.progress)}>
          <MdHowToReg size={20} {...stylex.props(styles.progressIcon)} />
          <div {...stylex.props(styles.track)}>
            <div {...fill} style={{
            ...fill.style,
            width: `${pct}%`
          }} />
          </div>
        </div>
      </div>
    </article>;
}
function Visibility({
  value
}: {
  value: PublicSpotGroup['visibility'];
}) {
  if (value === 'INVITE') {
    return <span {...stylex.props(styles.pill, styles.pillInvite)}><MdLock size={16} /></span>;
  }
  if (value === 'FRIENDS') {
    return <span {...stylex.props(styles.pill, styles.pillFriends)}><MdPeople size={16} /></span>;
  }
  return <span {...stylex.props(styles.pill, styles.pillPublic)}><MdPublic size={16} /></span>;
}
function Gender({
  value
}: {
  value: PublicSpotGroup['genderPolicy'];
}) {
  const Icon = value === 'MIXED' ? MdGroups : MdPerson;
  return <span {...stylex.props(styles.pill, styles.pillGender)}><Icon size={16} /></span>;
}